<app-card [iconSrc]="'assets/images/contracts/claims.svg'" [title]="'Canceled Reports'" class="card_claims">
  <div class="card-content">
    <div *ngIf='contracts?.length == 0' class="no-data">
      No Canceled Contracts yet
    </div>
    <div class="claim-list claims-styling" *ngIf='contracts?.length'>
      <div class="container-claim-list-table custom-table">
        <table class="table-style">
          <thead>
            <tr class="tr-style">
              <th class="th-style" scope="col">CONTRACT #</th>
              <th class="th-style" scope="col">CANCELED AT</th>
              <th class="th-style" scope="col">CREATED AT</th>
              <th class="th-style" scope="col">DEALER COMPANY</th>
            </tr>
          </thead>
          <tbody>
            <tr  *ngFor="let contract of contracts;index as i" class="tr-style">
              <td class="td td-style">
                <span >{{contract?.contract_number}}</span>
              </td>
              <td class="td td-style">
                <span >{{contract?.cancelled_at | formattedDate}}</span>
              </td>
              <td class="td td-style">
                <span >{{contract?.created_at | formattedDate}}</span>
              </td>
              <td class="td td-style">
                <span >{{contract?.creator?.third_party?.name}}</span>
              </td>
              <td class="td-style">
                <a [href]="'/dashboard/contracts/contract-details/' + contract.id" target="_blank">
                  <img src="./assets/images/file-text.svg" alt="edit" style="cursor: pointer;">
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-card>
